module.exports = __webpack_public_path__ + "img/LightningRoulette.bca15693.jpg";